import type { JSX } from 'solid-js';
import { Show } from 'solid-js';
import { Navigate } from '@solidjs/router';
import { useAuth } from '../context/AuthContext';
import { LoadingSpinner } from './LoadingSpinner';
import { useTranslation } from '../context/LanguageContext';

interface ProtectedRouteProps {
  children: JSX.Element;
  requireAdmin?: boolean;
  requireSupportAdmin?: boolean;
}

export function ProtectedRoute(props: ProtectedRouteProps) {
  const auth = useAuth();
  const { t } = useTranslation();
  const requireAdmin = () => props.requireAdmin ?? false;
  const requireSupportAdmin = () => props.requireSupportAdmin ?? false;

  // Explizit reaktiv: Show trackt isLoading, damit UI nach Session-Check sofort aktualisiert
  return (
    <Show when={!auth.isLoading} fallback={<LoadingSpinner fullScreen />}>
      <Show when={auth.isAuthenticated} fallback={<Navigate href="/login" />}>
        <Show
          when={!requireAdmin() || auth.user?.role === 'admin'}
          fallback={<Navigate href="/dashboard" />}
        >
          <Show
            when={!requireSupportAdmin() || auth.user?.role === 'admin' || auth.user?.role === 'supporter'}
            fallback={
              <div style={{ padding: '2rem', 'text-align': 'center', color: '#888' }}>
                <h2>{t('protectedRoute.accessDenied')}</h2>
                <p>{t('protectedRoute.needAdminOrSupporter')}</p>
              </div>
            }
          >
            {props.children}
          </Show>
        </Show>
      </Show>
    </Show>
  );
}
